import { apiRequest } from './api';

export const contentApiService = {
  getChannels: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return apiRequest(`/marketing-management/content-channels/${queryString ? `?${queryString}` : ''}`, 'GET');
  },

  createChannel: async (data) => apiRequest('/marketing-management/content-channels/', 'POST', data),
  updateChannel: async (id, data) => apiRequest(`/marketing-management/content-channels/${id}/`, 'PUT', data),
  deleteChannel: async (id) => apiRequest(`/marketing-management/content-channels/${id}/`, 'DELETE'),

  getPlans: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    const queryString = params.toString();
    return apiRequest(`/marketing-management/content-planner/${queryString ? `?${queryString}` : ''}`, 'GET');
  },

  createPlan: async (data) => apiRequest('/marketing-management/content-planner/', 'POST', data),
  updatePlan: async (id, data) => apiRequest(`/marketing-management/content-planner/${id}/`, 'PUT', data),
  deletePlan: async (id) => apiRequest(`/marketing-management/content-planner/${id}/`, 'DELETE'),
  uploadPlanPhotos: async (contentPlanId, files = [], photoGroup = 'post_grid', sortStart = 0) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('photo_group', photoGroup);
    formData.append('sort_start', String(sortStart));
    return apiRequest(`/marketing-management/content-planner/${contentPlanId}/photos/`, 'POST', formData);
  },
  deletePlanPhoto: async (photoId) => apiRequest(`/marketing-management/content-planner/photos/${photoId}/`, 'DELETE'),
  updatePlanPhoto: async (photoId, data) => apiRequest(`/marketing-management/content-planner/photos/${photoId}/update/`, 'PATCH', data),
};

const BASE_URL = '/content';

export const contentAPI = {
  // Blog Posts
  getBlogPosts: (params) => {
    const queryParams = new URLSearchParams(params).toString();
    return apiRequest(`${BASE_URL}/posts/${queryParams ? `?${queryParams}` : ''}`);
  },
  getBlogPostById: (id) => apiRequest(`${BASE_URL}/posts/${id}/`),
  createBlogPost: (data) => apiRequest(`${BASE_URL}/posts/`, {
    method: 'POST',
    body: data instanceof FormData ? data : JSON.stringify(data)
  }),
  updateBlogPost: (id, data) => apiRequest(`${BASE_URL}/posts/${id}/`, {
    method: 'PUT',
    body: data instanceof FormData ? data : JSON.stringify(data)
  }),
  partialUpdateBlogPost: (id, data) => apiRequest(`${BASE_URL}/posts/${id}/`, {
    method: 'PATCH',
    body: data instanceof FormData ? data : JSON.stringify(data)
  }),
  deleteBlogPost: (id) => apiRequest(`${BASE_URL}/posts/${id}/`, { method: 'DELETE' }),
  incrementBlogPostViewCount: (id) => apiRequest(`${BASE_URL}/posts/${id}/increment_view_count/`, { method: 'POST' }),

  // Blog Comments
  getBlogComments: (postId) => apiRequest(`${BASE_URL}/posts/${postId}/comments/`),
  createBlogComment: (postId, data) => apiRequest(`${BASE_URL}/comments/`, {
    method: 'POST',
    body: JSON.stringify({ ...data, blog_post: postId }),
    headers: { 'Content-Type': 'application/json' }
  }),
  updateBlogComment: (id, data) => apiRequest(`${BASE_URL}/comments/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' }
  }),
  deleteBlogComment: (id) => apiRequest(`${BASE_URL}/comments/${id}/`, { method: 'DELETE' }),
  approveBlogComment: (id) => apiRequest(`${BASE_URL}/comments/${id}/approve/`, { method: 'POST' }),

  // ChatGPT Integration
  generateBlogContent: (prompt, settingId = null) => {
    const payload = { prompt };
    if (settingId) {
      payload.setting_id = settingId;
    }
    return apiRequest(`${BASE_URL}/chatgpt/generate-blog/`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  translateText: (text, targetLang = 'English') => {
    return apiRequest(`${BASE_URL}/chatgpt/translate/`, {
      method: 'POST',
      body: JSON.stringify({ text, target_lang: targetLang })
    });
  },

  // ChatGPT Settings
  getChatGPTSettings: () => apiRequest(`${BASE_URL}/chatgpt_settings/`),
  getChatGPTSettingById: (id) => apiRequest(`${BASE_URL}/chatgpt_settings/${id}/`),
  createChatGPTSetting: (data) => apiRequest(`${BASE_URL}/chatgpt_settings/`, {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  updateChatGPTSetting: (id, data) => apiRequest(`${BASE_URL}/chatgpt_settings/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  partialUpdateChatGPTSetting: (id, data) => apiRequest(`${BASE_URL}/chatgpt_settings/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(data)
  }),
  deleteChatGPTSetting: (id) => apiRequest(`${BASE_URL}/chatgpt_settings/${id}/`, { method: 'DELETE' }),
  getActiveChatGPTSettings: () => apiRequest(`${BASE_URL}/chatgpt_settings/active/`),
  getDefaultChatGPTSetting: () => apiRequest(`${BASE_URL}/chatgpt_settings/default/`),
};

export default contentAPI;
